import { Fragment } from 'react';
import { DebtData } from '@common/hooks/useDebts/types';
import { Alert, Conditional, LazyImage, Text } from '@consumidor-positivo/aurora';
import isMobile from '@libs/utils/helpers/isMobile';
import { currencyToLocale } from '@libs/utils/helpers/currencyToLocale';
import { ClosedAgreementProps } from '@dues/pages/Partner/ClosedAgreement/types';

import './styles.scss';

interface CardSectionProps {
  debtData: DebtData;
  firstInstallmentExpDate: string;
  isRetryError?: boolean;
  closedAgreement?: ClosedAgreementProps;
}

const CardSection = ({ debtData, firstInstallmentExpDate, isRetryError, closedAgreement }: CardSectionProps) => {
  const formattedLabel = (label: string) => {
    return isMobile() ? label.replace(/g([^g]*)$/, 'g.:') : label;
  };

  const paymentMethod = closedAgreement?.flowWithPix && !closedAgreement?.singlePaymentMethod ? 'Pix/Boleto' : closedAgreement?.paymentMethod?.name;

  const creditor = debtData?.display?.name;
  const agreementValue = currencyToLocale(debtData?.paymentOpt?.valueAgreement);
  const qtyInstallments = debtData?.paymentOpt?.qtyInstallment;
  const installmentValue = debtData?.paymentOpt?.display?.entryValue;

  const retryData = [
    {
      title: 'Credor:',
      value: creditor,
    },
    {
      title: 'Valor do acordo:',
      value: agreementValue,
    },
    { title: formattedLabel('Forma de pagamento:'), value: paymentMethod },

    {
      title: 'Quantidade de parcelas:',
      value: `1 de ${qtyInstallments}`,
    },
    { title: 'Valor da parcela:', value: installmentValue },
  ];

  const paidData = [
    {
      title: 'Parcela:',
      value: `1 de ${qtyInstallments}`,
    },
    { title: formattedLabel('Forma de pagamento:'), value: 'Pix' },
    {
      title: formattedLabel('Data de pagamento:'),
      value: firstInstallmentExpDate,
    },
    { title: 'Total pago:', value: installmentValue },
  ];

  const getData = () => {
    if (isRetryError) return retryData;

    return paidData;
  };

  const dataToUse = getData();

  const showPartnerIcon = !isRetryError;
  const showRestrictionWarning = !isRetryError;

  return (
    <div className="card-section">
      <div className="card-section__card">
        <Conditional condition={showPartnerIcon} renderIf={<LazyImage width={40} height={40} src={debtData.display.partnerImage} />} />
        <div className="card-section__card-content">
          {dataToUse.map(({ title, value }) => (
            <Fragment key={`card-content-${title}`}>
              <div className="card-section__card-line">
                <Text color="secondary">{title}</Text>
                <Text color="secondary" weight="bold">
                  {value}
                </Text>
              </div>
              <div className="closed-agreement-page__divider" />
            </Fragment>
          ))}
        </div>
      </div>
      <Conditional
        condition={showRestrictionWarning}
        renderIf={
          <Alert type={2}>
            Se houver uma restrição no seu nome, <b>ela será removida em até 5 dias úteis</b> após a confirmação do pagamento.
          </Alert>
        }
      />
    </div>
  );
};

export default CardSection;
